module.exports = __webpack_public_path__ + "components/flag/static/square/np-bb262dd79f0c3bfb9a4b9fa49c1f59ce.svg";